module.exports = __webpack_public_path__ + "img/12600.fea91f82.jpg";